import { IEnterpriseMarketPricingsResponse } from '../../interfaces/enterprise-market-pricings.interface'

export interface EnterpriseMarketPricingsStateModel {
  marketPricings: IEnterpriseMarketPricingsResponse
}
